const ImageWithTextUX = () => {
    if ($('.section-image-with-text').length <= 0) return null;

    $('.section-image-with-text').each(function() {
        
        const $parent = $(this);
        
        const $imageSlider = $parent.find('.images-slider');
        const $textSlider = $parent.find('.text-slider')

        const $prevArrow = $parent.find('.custom-slider-arrow.prev');
        const $nextArrow = $parent.find('.custom-slider-arrow.next');

        const $dotsContainer = $parent.find('.it-slider-dots .inner-wrapper');

        //tooltip
        const $tooltipToggles = $parent.find('.tooltip-toggle');
        
        const $tooltipCloseDesk = $parent.find('.close-tooltip-popup.desk');
        const $tooltipCloseMob = $parent.find('.close-tooltip-popup.mob');
        
        const $tooltipPopupDesk = $parent.find('.it-contents .tooltip-content');
        const $tooltipPopupMob = $parent.find('.mobile-tooltip-popups .tooltip-content');

        const imageOpts = {
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 0,
            infinite: true,
            dots: true,
            arrows: true,
            prevArrow: $prevArrow,
            nextArrow: $nextArrow,
            appendDots: $dotsContainer,
            asNavFor: $textSlider,
            fade: true,
            waitForAnimate: false,
            autoplay: true,
            autoplaySpeed: 4000
        }

        const textOpts = {
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 0,
            infinite: true,
            dots: false,
            arrows: false,
            asNavFor: $imageSlider,
            waitForAnimate: false,
            swipe: false,
            fade: true,
            draggable: false,
        }

        $imageSlider.slick(imageOpts);
        $textSlider.slick(textOpts);
        
        $tooltipToggles.click(function() {
            //desktop
            if ($(window).width() >= 1200) {
                $parent.find('.tooltip-group.active .tooltip-content').stop().fadeOut(300);
                $parent.find('.tooltip-group.active').removeClass('active');

                $(this).closest('.tooltip-group').toggleClass('active')
                let $popup =  $tooltipPopupDesk.filter(`[data-popup-id="${$(this).data('trigger-id')}"]`)
                $popup.stop().fadeToggle(300); 
            } else {
                $parent.find('.mobile-tooltip-popups .tooltip-content.active').removeClass('active');

                let $popup = $tooltipPopupMob.filter(`[data-popup-id="${$(this).data('trigger-id')}"]`);
                $popup.addClass('active');
                $parent.find('.mobile-tooltip-popups').fadeIn(300);
            }
        })

        //close desktop
        $tooltipCloseDesk.click(function() {
            $(this).closest('.tooltip-content').stop().fadeOut(300);
            $(this).closest('.tooltip-group').removeClass('active');
        })

        //close mobile
        $tooltipCloseMob.click(function() {
            $(this).closest('.mobile-tooltip-popups').fadeOut(300);
        })
    })
}

export default ImageWithTextUX;